import { useState } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { authClient } from '../../auth';

/**
 * Reenvio do e-mail de confirmação.
 *
 * Sem isto, quem perde a mensagem fica sem saída: não consegue entrar (a conta
 * exige verificação) nem gerar um novo link. Aparece quando o login falha por
 * e-mail não confirmado e na tela seguinte ao cadastro.
 */
export function ReenviarVerificacao({
  email,
  retorno,
  aoEnviar,
}: {
  email: string;
  retorno?: string;
  /**
   * Chamado quando o novo link sai.
   *
   * A tela de entrada usa isto para apagar o "Confirme seu e-mail antes de
   * entrar" que a trouxe até aqui: com os dois no ar, o vermelho e o verde
   * ficavam empilhados, um contradizendo o clima do outro.
   */
  aoEnviar?: () => void;
}) {
  const [estado, setEstado] = useState<'inicial' | 'enviando' | 'enviado' | 'erro'>('inicial');

  const reenviar = async () => {
    setEstado('enviando');

    try {
      const { error } = await authClient.sendVerificationEmail({
        email,
        /*
         * O mesmo retorno do primeiro e-mail: quem veio comprar e pediu a
         * mensagem de novo não pode perder a intenção só por ter clicado aqui.
         * Sem `retorno`, o servidor usa o padrão, que é a raiz do app.
         */
        callbackURL: retorno ?? window.location.origin,
      });

      setEstado(error ? 'erro' : 'enviado');
      if (!error) aoEnviar?.();
    } catch {
      setEstado('erro');
    }
  };

  if (estado === 'enviado') {
    return (
      <Alert
        type="success"
        showIcon
        title="E-mail enviado"
        description={`Enviamos um novo link de confirmação para ${email}. Verifique também a caixa de spam.`}
      />
    );
  }

  return (
    <Space orientation="vertical" size={4}>
      {estado === 'erro' ? (
        <Alert
          type="error"
          showIcon
          title="Não conseguimos enviar agora. Tente novamente em instantes."
        />
      ) : null}

      <Typography.Text type="secondary">Não recebeu o e-mail?</Typography.Text>
      <Button onClick={() => void reenviar()} loading={estado === 'enviando'}>
        Reenviar confirmação
      </Button>
    </Space>
  );
}
